module.exports = __webpack_public_path__ + "img/mob-rightarw.4b3789e3.svg";